import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../api/client';

const Deals = () => {
  const [deals, setDeals] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    api.get('/api/spvs/')
      .then((r) => setDeals(r.data))
      .catch((e) => setError({ status: e.response?.status, detail: e.response?.data?.detail }));
  }, []);

  if (error?.status === 403) {
    return <main style={{ padding: '4rem 1rem', textAlign: 'center' }}><p role="alert">{error.detail}</p><Link to="/kyc">Complete your KYC</Link></main>;
  }
  if (error) return <main style={{ padding: '4rem 1rem', textAlign: 'center' }}><p role="alert">Could not load deals.</p></main>;
  if (!deals) return <main style={{ padding: '4rem 1rem', textAlign: 'center' }}><p>Loading…</p></main>;

  return (
    <main style={{ maxWidth: 900, margin: '0 auto', padding: '2rem 1rem' }}>
      <h1>Deals</h1>
      {deals.length === 0 ? <p>No deals are open to you right now.</p> : (
        <ul style={{ listStyle: 'none', padding: 0 }}>
          {deals.map((d) => (
            <li key={d.id} style={{ border: '1px solid #ddd', borderRadius: 8, padding: 12, margin: '12px 0' }}>
              <h2 style={{ margin: 0 }}><Link to={`/deals/${d.id}`}>{d.name}</Link></h2>
              <p>{d.locations.join(', ')} · {d.deal_type.replace('_', ' ')} · {d.status} · minimum {d.min_shares} shares</p>
            </li>
          ))}
        </ul>
      )}
    </main>
  );
};

export default Deals;
